(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("skillbuilderBridge", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/connections/skillBuilderBridge/skillBuilderBridgeView.html",
            controller: ["connectionsResource", "messageService", "$state", "$rootScope", SkillBuilderBridgeCtrl],
            controllerAs: "vm"
        };
        function SkillBuilderBridgeCtrl(connectionsResource, messageService, $state, $rootScope) {
            var vm = this;
            connectionsResource.getSkillBuilderBridgeViewModel(function (data) {
                vm.model = data;
            });
            vm.test = function () {
                vm.connectionSuccess = false;
                vm.connectionFail = false;
                connectionsResource.postBambooHRv1ImportTestConnection(vm.model, function () {
                    vm.connectionSuccess = true;
                }, function () {
                    vm.connectionFail = true;
                });
            };
            vm.import = function () {
                if (vm.importing)
                    return;
                vm.importing = true;
                vm.importResult = null;
                vm.pushAccountsResult = null;
                vm.pushCompletionsResult = null;
                connectionsResource.postSkillBuilderBridgeImportRunNow(function (result) {
                    vm.importing = false;
                    vm.importResult = result;
                    $rootScope.$broadcast("checkSubscription");
                    connectionsResource.getSkillBuilderBridgeViewModel(function (data) {
                        vm.model = data;
                    });
                }, function (error) {
                    vm.importing = false;
                    messageService.error(error);
                });
            };
            vm.pushAccounts = function () {
                if (vm.pushingAccounts)
                    return;
                vm.pushingAccounts = true;
                vm.importResult = null;
                vm.pushAccountsResult = null;
                vm.pushCompletionsResult = null;
                connectionsResource.postSkillBuilderBridgeAccountExportRunNow(function (result) {
                    vm.pushingAccounts = false;
                    vm.pushAccountsResult = result;
                    connectionsResource.getSkillBuilderBridgeViewModel(function (data) {
                        vm.model = data;
                    });
                }, function (error) {
                    vm.pushingAccounts = false;
                    messageService.error(error);
                });
            };
            vm.pushCompletions = function () {
                if (vm.pushingCompletions)
                    return;
                vm.pushingCompletions = true;
                vm.importResult = null;
                vm.pushAccountsResult = null;
                vm.pushCompletionsResult = null;
                connectionsResource.postSkillBuilderBridgeCompletionExportRunNow(function (result) {
                    vm.pushingCompletions = false;
                    vm.pushCompletionsResult = result;
                    connectionsResource.getSkillBuilderBridgeViewModel(function (data) {
                        vm.model = data;
                    });
                }, function (error) {
                    vm.pushingCompletions = false;
                    messageService.error(error);
                });
            };
            vm.cancel = function () {
                $state.go("main.settings.connections");
            };
        }
    });
}());
